/* ------------------------------------------------------------------------------
@name: Modal Detail
@description: Modal Detail
--------------------------------------------------------------------------------- */

const ModalDetail = (() => {
  const $modal = $('.modal-detail');
  const $carousel = $('.js-modal-carousel');
  const $indexDisplay = $modal.find('.modal-detail__index');
  let totalItems = 0;

  // - handleClickProjectItem
  const handleClickProjectItem = () => {
    // Bersihkan binding lama untuk menghindari duplikasi
    $(document).off(
      'click.modalProjectTxt click.modalProjectImg click.modalSearchItem click.modalDetailThumb click.modalDetailSection'
    );

    // Search result generic (tetap slide pertama)
    $(document).on('click.modalSearchItem', '.search-result__item', function () {
      const $item = $(this);
      const gallery = $item.data('gallery');
      if (!gallery || !Array.isArray(gallery)) return;
      buildCarouselAndShow(gallery, 0);
    });

    // Project: klik teks => buka slide pertama
    $(document).on('click.modalProjectTxt', '.project__card__item--txt', function () {
      const $txt = $(this);
      const gallery = $txt.data('gallery');
      if (!gallery || !Array.isArray(gallery)) return;
      buildCarouselAndShow(gallery, 0);
    });

    // Project: klik image => buka berdasarkan index image
    $(document).on('click.modalProjectImg', '.project__card__item--img', function () {
      const $img = $(this);
      const projectId = $img.data('id');
      const $txt = $('.project__card__item--txt[data-id="' + projectId + '"]');
      let gallery = $txt.data('gallery');
      if (!gallery || !Array.isArray(gallery)) return;
      // Kumpulan image sibling untuk project yang sama
      const $siblings = $('.project__card__item--img[data-id="' + projectId + '"]');
      let startIndex = $siblings.index($img); // 0-based
      if (startIndex < 0) startIndex = 0;
      if (startIndex > gallery.length - 1) startIndex = gallery.length - 1;
      buildCarouselAndShow(gallery, startIndex);
    });

    // Experience: klik thumbnail image => sesuai index
    $(document).on('click.modalDetailThumb', '.experience-detail__item__img', function () {
      const $thumb = $(this);
      const $section = $thumb.closest('.experience-detail__item');
      let gallery = $section.data('gallery');
      if (!gallery || !Array.isArray(gallery)) return;
      const $siblings = $section.find('.experience-detail__item__img');
      let startIndex = $siblings.index($thumb);
      if (startIndex < 0) startIndex = 0;
      if (startIndex > gallery.length - 1) startIndex = gallery.length - 1;
      buildCarouselAndShow(gallery, startIndex);
    });

    // Experience: klik area section (bukan thumbnail) => slide pertama
    $(document).on('click.modalDetailSection', '.experience-detail__item', function (e) {
      if ($(e.target).closest('.experience-detail__item__img').length) return; // sudah ditangani
      const $section = $(this);
      let gallery = $section.data('gallery');
      if (!gallery || !Array.isArray(gallery)) return;
      buildCarouselAndShow(gallery, 0);
    });
  };

  const buildCarouselAndShow = (gallery, startIndex = 0) => {
    let baseUrl = $('body').data('base-url');
    if (typeof baseUrl === 'undefined') baseUrl = '';
    const $container = $('.modal-detail__carousel');
    $container.empty();
    gallery.forEach((data) => {
      let html = '';
      if (data.type === 'image') {
        html = `
          <div class="modal-detail__item">
            <div class="modal-detail__top">
              <div class="modal-detail__img">
                <img class="modal-detail__img__el" src="${data.image}" alt="${data.title}">
              </div>
            </div>
            <div class="modal-detail__bottom">
              <div class="modal-detail__txt">
                <h6 class="modal-detail__title">${data.title}</h6>
                <p class="modal-detail__date">${data.subtitle}</p>
                <p class="modal-detail__description">${data.description}</p>
              </div>
            </div>
          </div>`;
      } else if (data.type === 'video') {
        html = `
          <div class="modal-detail__item">
            <div class="modal-detail__top">
              <div class="modal-detail__media" data-youtube="${data.youtube_id}">
                <img class="modal-detail__cover" src="${data.image}" alt="${data.title}" />
                <div class="modal-detail__play-icon">
                  <img src="${baseUrl}assets/img/logo/button-play.svg" alt="play" />
                </div>
              </div>
            </div>
            <div class="modal-detail__bottom">
              <div class="modal-detail__txt">
                <h6 class="modal-detail__title">${data.title}</h6>
                <p class="modal-detail__date">${data.subtitle}</p>
                <p class="modal-detail__description">${data.description}</p>
              </div>
            </div>
          </div>`;
      }
      $container.append(html);
    });
    show(startIndex);
  };

  const updateIndex = (event) => {
    const index = (event.item.index % event.item.count) + 1;
    totalItems = event.item.count;
    $indexDisplay.text(`${index}/${totalItems}`);
  };

  const resetAllVideos = () => {
    let baseUrl = $('body').data('base-url');
    if (typeof baseUrl === 'undefined') baseUrl = '';
    $carousel.find('.modal-detail__media').each(function () {
      const $media = $(this);
      const youtubeId = $media.data('youtube');

      // Check if iframe exists → replace with cover again
      if ($media.find('iframe').length > 0) {
        const cover = $media.data('cover') || $media.find('img').attr('src');
        const alt = $media.find('img').attr('alt') || '';

        // Replace iframe with original image & play icon
        $media.html(`
          <img class="modal-detail__cover" src="${cover}" alt="${alt}" />
          <div class="modal-detail__play-icon">
            <img src="${baseUrl}assets/img/logo/button-play.png" alt="button-play" />
          </div>
        `);

        // Rebind click event again after reset
        bindVideoClick($media, youtubeId, cover, alt);
      }
    });
  };

  const bindVideoClick = ($media, youtubeId, cover, alt) => {
    $media.one('click', function () {
      $media.html(`
        <iframe
          src="https://www.youtube.com/embed/${youtubeId}?autoplay=1&enablejsapi=1&controls=0&modestbranding=0&rel=0&showinfo=0"
          frameborder="0"
          allow="autoplay"
          allowfullscreen>
        </iframe>
      `);
    });
  };

  const initCarousel = () => {
    if ($carousel.hasClass('owl-carousel')) {
      $carousel.owlCarousel('destroy').removeClass('owl-carousel');
    }

    const itemCount = $carousel.find('.modal-detail__item').length;

    if (itemCount > 1) {
      $carousel.addClass('owl-carousel').owlCarousel({
        items: 1,
        rewind: false,
        loop: false,
        nav: true,
        dots: false,
        smartSpeed: 500,
        touchDrag: true,
        mouseDrag: true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        onInitialized: updateIndex,
        onChanged: function (event) {
          updateIndex(event);
          resetAllVideos();
        }
      });
    } else {
      $carousel.removeClass('owl-carousel').addClass('modal-detail--single');
      totalItems = 1;
      $indexDisplay.text(`1/1`);
    }

    // Initialize video click handlers
    $carousel.find('.modal-detail__media').each(function () {
      const $media = $(this);
      const youtubeId = $media.data('youtube');
      const cover = $media.find('img').attr('src');
      const alt = $media.find('img').attr('alt') || '';
      if (!$media.data('cover')) {
        $media.data('cover', cover);
      }
      bindVideoClick($media, youtubeId, cover, alt);
    });
  };

  const show = (startIndex = 0) => {
    $('body').addClass('show-modal');
    $modal.fadeIn(300, () => {
      initCarousel();
      if (startIndex > 0 && $carousel.hasClass('owl-carousel')) {
        $carousel.trigger('to.owl.carousel', [startIndex, 0]);
      }
    });
  };

  const bindEvents = () => {
    $('.modal-detail__close').on('click', () => {
      resetAllVideos();
      $('body').removeClass('show-modal');
    });

    $(document).on('keydown', (e) => {
      if (e.key === 'Escape') {
        resetAllVideos();
        $('body').removeClass('show-modal');
      }
    });
  };

  const init = () => {
    bindEvents();
    handleClickProjectItem();
  };

  return {
    init
  };
})();

export default ModalDetail;
